import type {ActionCreator} from '@base/redux-utils'
import {actionCreator} from '@base/redux-utils'

import type {PageInfo} from './selectors'

export type HistoryChangedPayload = {
  pathname: string
  search: string | undefined | null
  hash: string | undefined | null
  timestamp?: number
}
export const HISTORY_CHANGED = 'navigation/HISTORY_CHANGED'
export const historyChanged: ActionCreator<HistoryChangedPayload> =
  actionCreator(HISTORY_CHANGED)
export const NAVIGATION_STARTED = 'navigation/NAVIGATION_STARTED'
export const navigationStarted: ActionCreator<HistoryChangedPayload> =
  actionCreator(NAVIGATION_STARTED)
export type NavigationContinuePayload = {
  pathname: string
  search: string | undefined | null
  hash: string | undefined | null
}
export const NAVIGATION_CONTINUED = 'navigation/NAVIGATION_CONTINUED'
export const navigationContinued: ActionCreator<NavigationContinuePayload> =
  actionCreator(NAVIGATION_CONTINUED)
export const PAGE_MOUNTED = 'navigation/PAGE_MOUNTED'
export const pageMounted: ActionCreator<PageInfo> = actionCreator(PAGE_MOUNTED)
export const PAGE_UNMOUNTED = 'navigation/PAGE_UNMOUNTED'
export const pageUnmounted: ActionCreator<{
  mountId: string
}> = actionCreator(PAGE_UNMOUNTED)
export const PAGE_UPDATED = 'navigation/PAGE_UPDATED'
export const pageUpdated: ActionCreator<PageInfo> = actionCreator(PAGE_UPDATED)
export const NAVIGATION_PROGRESS = 'navigation/NAVIGATION_PROGRESS'
export const navigationProgress: ActionCreator<{
  progress: number
}> = actionCreator(NAVIGATION_PROGRESS)
export type NavigationFinishedPayload = {
  asyncTime: number
  moduleTime: number
  controller?: string | null
  method?: string | null
  progress?: number
}
export const NAVIGATION_FINISHED = 'navigation/NAVIGATION_FINISHED'
export const navigationFinished: ActionCreator<NavigationFinishedPayload> =
  actionCreator(NAVIGATION_FINISHED)
export const REQUEST_QUEUE_CHANGED = 'navigation/REQUEST_QUEUE_CHANGED'
export const requestsQueueChanged: ActionCreator<{
  queue: Map<number, any>
}> = actionCreator(REQUEST_QUEUE_CHANGED)
export type ControllerMethodUpdatePayload = {
  controller: string | undefined | null
  method: string | undefined | null
}
export const CONTROLLER_METHOD_UPDATE = 'navigation/CONTROLLER_METHOD_UPDATE'
export const controllerMethodUpdate: ActionCreator<ControllerMethodUpdatePayload> =
  actionCreator(CONTROLLER_METHOD_UPDATE)

export const REFRESH_ON_NAVIGATION_SCHEDULED =
  'navigation/REFRESH_ON_NAVIGATION_SCHEDULED'
export const refreshOnNavigationScheduled: ActionCreator<string> =
  actionCreator(REFRESH_ON_NAVIGATION_SCHEDULED)

export const SHOW_NOT_FOUND_PAGE = 'navigation/SHOW_NOT_FOUND_PAGE'
export const showNotFoundPage: ActionCreator =
  actionCreator(SHOW_NOT_FOUND_PAGE)

export const SHOW_ERROR_PAGE = 'navigation/SHOW_ERROR_PAGE'
export const showErrorPage: ActionCreator = actionCreator(SHOW_ERROR_PAGE)
